// @flow
import assert from 'assert';
import ko from 'rgs-knockout';
import _ from 'lodash';

import Q from 'q';

export interface BaseDictionarySingletonInterface {
	_firstUpdate: () => Promise;
	update: () => Promise;
	_data: Array<Object>;
	data: Array<Object>;
}

export class BaseDictionarySingleton implements BaseDictionarySingletonInterface {
	constructor () {
		this._data = ko.observable();

		this._firstUpdate = this.update();
	}

	update () {
		return new Q();
	}

	ready () {
		return this._firstUpdate;
	}

	data () {
		assert(
			this.ready().inspect().state === 'fulfilled',
			'Wait for `.ready()` before you can access to data'
		);

		return _.clone(this._data());
	}
}